import {useMemo} from 'react';
import {usePolling} from './usePolling';
import {getAccountStatus} from '../api/account';

export function useAccountStatus({enabled = true} = {}) {
    const {data, error, refetch} = usePolling(getAccountStatus, 15000, {enabled});

    return useMemo(() => ({
        credits: data?.credits || 0,
        creditsBreakdown: data?.credits_breakdown || {subscription: 0, topup: 0, total: 0},
        musicCredits: data?.music_credits || 0,
        musicCreditsBreakdown: data?.music_credits_breakdown || {subscription: 0, topup: 0, total: 0},
        skazkiCredits: data?.skazki_credits || 0,
        skazkiCreditsBreakdown: data?.skazki_credits_breakdown || {subscription: 0, topup: 0, total: 0},
        subscription: data?.subscription || null,
        linkedTelegramId: data?.linked_telegram_id || null,
        linkedMaxId: data?.linked_max_id || null,
        history: data?.generations || [],
        musicHistory: data?.music_generations || [],
        skazkiHistory: data?.skazki_generations || [],
        error,
        refetch,
    }), [data, error, refetch]);
}
